import { render, staticRenderFns } from "./about-social-civil.vue?vue&type=template&id=54c26647"
import script from "./about-social-civil.vue?vue&type=script&lang=js"
export * from "./about-social-civil.vue?vue&type=script&lang=js"
import style0 from "./about-social-civil.vue?vue&type=style&index=0&id=54c26647&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports